export default __webpack_public_path__ + "static/media/frg--walking-trails.c45b84c5.png";